"use client";

import { useCallback, useSyncExternalStore } from "react";

import { LARGURA_MINIMA_DO_DIALOGO_PX } from "../components/modal/apresentacao";

export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      const media = window.matchMedia(query);
      media.addEventListener("change", onStoreChange);
      return () => media.removeEventListener("change", onStoreChange);
    },
    [query],
  );

  const getSnapshot = () => window.matchMedia(query).matches;

  /** Mobile-first no SSR — evita branch desktop no servidor. */
  const getServerSnapshot = () => false;

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

/** Diálogo a partir desta largura, folha abaixo — ver `modal/apresentacao.ts`. */
export const DESKTOP_MODAL_MEDIA_QUERY = `(min-width: ${LARGURA_MINIMA_DO_DIALOGO_PX}px)`;
